import React from "react";

import "swiper/css";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";

import partner1 from "../home page/Partners pics/1.png";
import partner3 from "../home page/Partners pics/3.png";
import partner4 from "../home page/Partners pics/4.png";
import partner5 from "../home page/Partners pics/5.png";
import partner6 from "../home page/Partners pics/6.png";
function Parteners() {
  return (
    <div>
      <div className="my-[120px] overflow-hidden">
        <h1 className="mb-[40px] main-X-titles flex justify-center font-font1 font-bold">
          Partners
        </h1>
        <Splide
          options={{
            rewind: true,
            gap: "1rem",
            perPage: 4,
            drag: "free",
            height: "8rem",
            wheel: true,
            autoplay: true,
            interval: 3000,

            breakpoints: {
              900: {
                perPage: 3,
              },
              700: {
                perPage: 2,
                gap: "1rem",
              },
              400: {
                perPage: 1,
              },
            },
            arrows: false,
          }}
        >
          <SplideSlide className="flex justify-center">
            <img src={partner1} alt={`slide1`} className="h-14" />
          </SplideSlide>
          <SplideSlide className="flex justify-center">
            <img src={partner3} alt={`slide2`} className="h-14" />
          </SplideSlide>
          <SplideSlide className="flex justify-center">
            <img src={partner4} alt={`slide2`} className="h-14" />
          </SplideSlide>
          <SplideSlide className="flex justify-center">
            <img src={partner5} alt={`slide2`} className="h-14" />
          </SplideSlide>
          <SplideSlide className="flex justify-center">
            <img src={partner6} alt={`slide2`} className="h-14" />
          </SplideSlide>
        </Splide>
      </div>
    </div>
  );
}

export default Parteners;
